var _circle, _mask, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10.9545,
    cy: 10.9545,
    r: 6.95455,
    fill: "white"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 4,
    y: 4,
    width: 14,
    height: 14
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 10.9545,
    cy: 10.9545,
    r: 6.95455,
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 13.7576,
    width: 13.9091,
    height: 5.15151,
    fill: "#DB5F7B"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 8.60602,
    width: 13.9091,
    height: 5.15151,
    fill: "#B7D16D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 3.45453,
    width: 13.9091,
    height: 5.15151,
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBg);
export default __webpack_public_path__ + "static/media/bg.4a7b1511b6d1815ad9a342fa4cbb70e9.svg";
export { ForwardRef as ReactComponent };